import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class OpenAiService {
  private http = inject(HttpClient);
  chat(prompt: string) {
    const url = `${environment.apiBaseUrl}/openai/chat`;

    return this.http.post<any>(url, { 
      model: 'gpt-3.5-turbo',
      messages: [
{
  role: 'system',
  content: `Du bist ein technischer Assistent für einen erfahrenen Freelancer (Hüseyin Korkut), der Angular und Spring Boot beherrscht. 
  Deine Aufgabe ist es, technische Fragen kompetent, praxisnah und sympathisch zu beantworten – als würdest du dem Kunden direkt helfen wollen, ein Projekt zu starten. 
  Du darfst gerne konkrete Tipps geben, z.B. zu Architektur, Modernisierung oder Cloud-Migration.`
},
        { role: 'user', content: prompt }
      ]
          });
  }

  
}
